// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Home_spinnerContainer__17u0A","spinner":"Home_spinner__qTE9S"};